export const userConfig = {
  maxFailedLogins: 5,
}
export const AGREEMENT_VERSION = 1
